import { Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import BannerImage from '@images/external_payment/campaign_banner.webp'

export const CampaignBanner = () => <Image src={buildAssetUrlString(BannerImage)} alt="マンガBANGショップはいつでも10%OFF!" w="100%" h="auto" />
